import React from 'react';
import { Button, Tabs } from 'antd';

/** 管理后台已登录壳：顶栏 + Tabs */
export default function AdminPanelShell({
  adminName,
  onLogout,
  activeTab,
  onTabChange,
  tabItems
}) {
  return (
    <div
      className="zhxt-admin-panel"
      style={{ maxWidth: 1100, margin: '40px auto', padding: 24, border: '1px solid #e0e0e0', borderRadius: 10, background: '#fafbfc', boxShadow: '0 2px 12px #0001', position: 'relative' }}
    >
      <div style={{ position: 'absolute', right: 24, top: 24, display: 'flex', alignItems: 'center', gap: 16 }}>
        <span style={{ color: '#1976d2', fontWeight: 600 }}>欢迎, {adminName || '管理员'}</span>
        <Button type="primary" onClick={() => { window.location.href = '/'; }}>返回首页</Button>
        <Button danger onClick={onLogout}>退出</Button>
      </div>
      <h2 style={{ color: '#1976d2', marginBottom: 12 }}>管理后台</h2>
      {tabItems.length === 0 ? (
        <div style={{ padding: 24, color: '#666' }}>当前账号没有可显示的管理模块，请联系管理员授权。</div>
      ) : (
        <Tabs activeKey={activeTab} onChange={onTabChange} items={tabItems} />
      )}
    </div>
  );
}
